import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import toast, { Toaster } from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import PreferencesNav from "./PreferencesNav";
import AddIcon from "@mui/icons-material/Add";
import Select from "react-select";

import {
    addTDS,
    editTDS,
    getOrgList,
    getVendorByWare,
    getWarehouseKeyValueDetailsList,
} from "../../services/index";
import { addStore, editStore, getStoreAllRecord } from "../../services/Purchase/StoreService";
import { STORE_BASE_URL, WAREHOUSE_URL } from "../../CONSTANTS";
import { callGetAxios } from "../../services/common/common";
import PaginationDataTable from "../Common/PaginationDataTable";

const storeObj = {
    organisationId: "",
    organisationTitle: "",
    recordId: "",
    title: "",
    wareHouseId: "",
    wareHouseTitle: ""
}

const Store = () => {
    const [tdsInfo, setTdsInfo] = useState({});
    const [filteredData, setFilteredData] = useState([]);
    const [wareOptions, setWareOptions] = useState([]);
    const [orgOptions, setOrgOptions] = useState([]);
    const [record, setRecord] = useState(storeObj);

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setRecord(storeObj);
        setWareOptions([])
        setShow(false);
    };

    useEffect(() => {
        getStoreList();
        getOrganizationList();
    }, []);

    const getOrganizationList = () => {
        getOrgList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    key: d.recordLongId,
                    value: d.recordId,
                    label: d.organisationTitle,
                }));
                setOrgOptions(options);
            } else {
                toast(res);
            }
        });
    }

    const getStoreList = () => {
        var data = {
            page: 0,
            search: "",
            size: -1,
        };
        getStoreAllRecord(data).then((res) => {
            if (res.errorCode == 0) {
                var d = res.responsePacket.data;
                setFilteredData(d);
            } else {
                toast(res.message);
                return;
            }
        });
    };

    const getWarehouseKeyValueList = (id) => {
        callGetAxios(WAREHOUSE_URL() + "getRecordByOrganisationId/" + id, "WarehouseKeyValueById").then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.recordId,
                    label: d.title,
                }));
                setWareOptions(options);
            } else {
                toast(res);
            }
        });
    };

    const columns = [
        {
            name: "Title",
            cell: (row) => row.title,
        },
        {
            name: "Warehouse Title",
            cell: (row) => row.wareHouseTitle,
        },
        {
            name: "Organization Title",
            cell: (row) => row.organisationTitle,
        },
    ];

    const handleClicked = (row) => {
        const _organisationId = orgOptions?.find((item) => item.label === row?.organisationTitle);
        setRecord((prev) => ({ ...prev, organisationId: _organisationId }));
        callGetAxios(WAREHOUSE_URL() + "getRecordByOrganisationId/" + _organisationId?.key, "WarehouseKeyValueById").then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.recordId,
                    label: d.title,
                }));
                setWareOptions(options);
                const _warehouseId = options?.find((item) => item.label === row?.wareHouseTitle)
                setRecord({
                    ...record,
                    recordId: row?.recordId,
                    title: row?.title,
                    organisationId: _organisationId,
                    wareHouseId: _warehouseId
                });
            } else {
                toast(res);
            }
        });
        setShow(true);
    };

    const handleData = (e) => {
        setRecord({
            ...record,
            [e.target.name]: e.target.value,
        });
    };

    const handleSave = () => {
        if (!record.organisationId) {
            toast("Please select Organization");
            return;
        }
        if (!record.wareHouseId) {
            toast("Please select Warehouse");
            return;
        }
        if (!record.title) {
            toast("Please fill title");
            return;
        }

        const data = {
            organisationId: record.organisationId?.value,
            organisationTitle: record.organisationId?.label,
            wareHouseTitle: record.wareHouseId?.label,
            wareHouseId: record.wareHouseId?.value,
            title: record?.title,
        };
        if (record.recordId) {
            editStore(record.recordId, data).then((res) => {
                if (res.errorCode == 0) {
                    toast.success(res.message);
                    getStoreList();
                    handleClose();
                } else {
                    toast(res.message);
                    return;
                }
            });
        } else {
            addStore(data).then((res) => {
                if (res.errorCode == 0) {
                    toast.success(res.message);
                    getStoreList();
                    handleClose();
                } else {
                    toast(res.message);
                    return;
                }
            });
        }
    };

    const handleSelect = (e, name) => {
        if (name === "org") {
            getWarehouseKeyValueList(e.key);
            setRecord((prev) => ({ ...prev, organisationId: e, wareHouseId: {} }));
        } else {
            setRecord((prev) => ({ ...prev, wareHouseId: e }))
        }
    }



    return (
        <>
            <Modal show={show} onHide={handleClose} size="sm">
                <Modal.Header>STORE INFO</Modal.Header>
                <Modal.Body>
                    <table>
                        <tr>
                            <td>Organization:</td>
                            <Select options={orgOptions} value={record.organisationId} onChange={(e) => handleSelect(e, "org")} isDisabled={record.recordId} />
                        </tr>
                        <tr>
                            <td>Warehouse:</td>
                            <Select options={wareOptions} value={record.wareHouseId} onChange={(e) => handleSelect(e, "ware")} isDisabled={record.recordId} />
                        </tr>
                        <tr>
                            <td>Title:</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    className="form-control"
                                    type="text"
                                    name="title"
                                    value={record.title}
                                    onChange={(e) => handleData(e)}
                                />
                            </td>
                        </tr>
                    </table>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* <div className="column list-column d-print-none column-small">
                <PreferencesNav />
            </div> */}
            <div className="column content-column">
                <div className="header clearfix" style={{ borderBottom: "none" }}>
                    <span className="float-left" style={{ fontSize: "35px" }}>
                        Store
                    </span>
                </div>


                <div style={{ height: 500, width: "100%" }}>
                    <PaginationDataTable
                        paginationUrl={STORE_BASE_URL() + 'getAllRecords'}
                        serverSidePagination={true}
                        search={true}
                        pagination={false}
                        columns={columns}
                        onRowClicked={(data) => {
                            handleClicked(data);
                        }}
                        storeRackCellPallet={true}
                        onNewClicked={() => setShow(true)}
                    // fixedHeader
                    // subHeader
                    // subHeaderComponent={
                    //     <>
                    //         <button
                    //             id="ember5839"
                    //             className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                    //             type="button"
                    //             onClick={() => setShow(true)}
                    //         >
                    //             <AddIcon />
                    //             New
                    //         </button>
                    //     </>
                    // }
                    />
                </div>
            </div>
            <Toaster />
        </>
    );
};

export default Store;
